import React from 'react'
import Break from '../DMGComponents/Break'
import { renewArea, deleteArea, getUpgradeAreaSettings, upgradeArea, updateNotifyOwnerOnDownload } from '../fetchData';
import Checkbox from '../DMGComponents/Checkbox';
import toast, { Toaster } from 'react-hot-toast';
import Button from '../DMGComponents/Button';
import { confirmAlert } from 'react-confirm-alert';
import '../assets/css/react-confirm-alert.css'
import Select from '../DMGComponents/Select'
import Spinner from './Spinner';
import AreaInfoIcon from '../assets/img/info-square.svg'; 

class AreaInfo extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            actionInProgress: false,
            showUpgradeArea: false,
            areaSettings: [],
            selectedAreaSetting: null,
            upgradeInProgress: false,
            notifyOwnerOnDownload: props.area.notifyOwnerOnDownload || false
        }
    }

    renewArea = () => {
        this.setState({ actionInProgress: true });
        renewArea(this.props.area.id).then((res) => {
            this.props.updateAreaExpiration(res);
            toast.success("Renewed area.");
            this.setState({ actionInProgress: false });
        }).catch((err) => {
            toast.error(err);
            this.setState({ actionInProgress: false });
        })
    }

    upgradeArea = () => {
        this.setState({ actionInProgress: true, upgradeInProgress: true });
        upgradeArea(this.props.area.id, this.state.selectedAreaSetting.id).then((res) => {
            this.props.updateAreaSettings(res);
            toast.success("Upgraded area.");
            this.setState({ actionInProgress: false, upgradeInProgress: false, showUpgradeArea: false });
        }).catch((err) => {
            toast.error(err);
            this.setState({ actionInProgress: false, upgradeInProgress: false });
        })
    }

    loadUpgradeAreaSettings = () => {
        getUpgradeAreaSettings(this.props.area.id).then((res) => {
            let arr = []
            res.forEach(e => {
                arr.push({ displayName: e.name, data: { id: e.id, name: e.name } })
            });
            this.setState({
                areaSettings: arr
            })
        }).catch((err) => {
            toast.error("Error loading area settings.")
            console.error("Error", err)
        })
    }

    openCloseAreaUpgrade = () => {
        if (!this.state.showUpgradeArea) {
            this.loadUpgradeAreaSettings();
        }
        this.setState({ showUpgradeArea: !this.state.showUpgradeArea });
    }

    toggleNotifyOwnerOnDownload = (newValue) => {
        this.setState({ notifyOwnerOnDownload: newValue });
        updateNotifyOwnerOnDownload(this.props.area.id, newValue).then(() => {
            toast.success("Notification setting updated.");
        }).catch(() => {
            toast.error("Error updating notification setting.");
            this.setState({ notifyOwnerOnDownload: !newValue });
        });
    }

    deleteArea = async () => {
        confirmAlert({
            title: 'Delete Area',
            message: "Are you sure you want to delete area " + this.props.area.name + "?",
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        this.setState({ actionInProgress: true });
                        deleteArea(this.props.area.id).then(() => {
                            this.props.removeArea();
                        }).catch(() => {
                            toast.error("Error deleting area.");
                            this.setState({ actionInProgress: false });
                        })
                    }
                },
                {
                    label: 'No',
                    onClick: () => { return }
                }
            ]
        });
    }

    render() {
        const area = this.props.area;
        return (
            <div style={{ ...this.props.style, textAlign: "left" }} className="fileExChildComponent">
                <Toaster />
                <Break style={{ margin: "16px 0 12px 0" }}>
                    <div style={{ display: "flex" }}>
                        <div style={{ marginRight: "44px" }}>
                            <img
                                src={AreaInfoIcon}
                                alt="Area Info"
                                style={{ height: "2rem", position: "absolute" }}
                            />
                        </div>
                        <div>
                            Area Info
                        </div>
                    </div>
                </Break>
                <div style={{ display: "flex" }}>
                    <div style={{ flex: "1", marginRight: "12px" }}>
                        <table
                            style={{ width: "100%" }}
                        >
                            <tbody>
                                <tr>
                                    <td style={{ textAlign: "left" }}>
                                        Creation Date
                                    </td>
                                    <td style={{ textAlign: "right", fontWeight: 700 }}>
                                        {new Date(area.creationTimeUnixMs).toLocaleString()}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "left" }}>
                                        Expiration Date
                                    </td>
                                    <td style={{ textAlign: "right", fontWeight: 700 }}>
                                        {area.doesNotExpire ?
                                            'Never' :
                                            new Date(area.expirationDateUnixMs).toLocaleString()
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div style={{ flex: "1", marginLeft: "12px" }}>
                        <table
                            style={{ width: "100%" }}
                        >
                            <tbody>
                                <tr>
                                    <td style={{ textAlign: "left" }}>
                                        Max. area space
                                    </td>
                                    <td style={{ textAlign: "right", fontWeight: 700 }}>
                                        {area.areaSpace}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "left" }}>
                                        Max. file space
                                    </td>
                                    <td style={{ textAlign: "right", fontWeight: 700 }}>
                                        {area.fileSpace}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                {area.isOwner &&
                    <div style={{ display: "flex", justifyContent: "right", marginTop: "12px", marginBottom: "8px" }}>
                        <Checkbox
                            checked={this.state.notifyOwnerOnDownload}
                            onClick={this.toggleNotifyOwnerOnDownload}
                        >
                            I want to be notified when users download files from this area.
                        </Checkbox>
                    </div>
                }
                <div style={{ display: "flex", justifyContent: "right", marginBottom: "12px", marginTop: '8px' }}>
                    {area.isOwner &&
                        <div style={{ display: "flex", justifyContent: "right", marginBottom: "4px", marginTop: "8px", marginRight: "12px" }}>
                            <Button type="hover-bottom-left" onClick={() => { this.deleteArea() }} disabled={this.state.actionInProgress}>Delete Area</Button>
                        </div>
                    }
                    {!area.doesNotExpire && area.isOwner &&
                        <div style={{ display: "flex", justifyContent: "right", marginBottom: "4px", marginTop: "8px", marginRight: "12px" }}>
                            <Button type="hover-bottom-left" onClick={() => { this.renewArea() }} disabled={this.state.actionInProgress}>Renew Area</Button>
                        </div>
                    }
                    {!this.props.isAdHoc && area.isOwner &&
                        <div style={{ display: "flex", justifyContent: "right", marginBottom: "4px", marginTop: "8px" }}>
                            <Button type="hover-bottom-left" onClick={() => { this.openCloseAreaUpgrade() }} disabled={this.state.actionInProgress}>Upgrade Area</Button>
                        </div>
                    }
                </div>
                {!this.props.isAdHoc && this.state.showUpgradeArea &&
                    <div>
                        {this.state.upgradeInProgress &&
                            <><div style={{ textAlign: "center" }}>
                                <Spinner />
                            </div></>
                        }
                        {!this.state.upgradeInProgress &&
                            <div>
                                <div>
                                    <Select
                                        label="Area setting"
                                        options={this.state.areaSettings}
                                        onChange={(e) => { this.setState({ selectedAreaSetting: e }) }}
                                    />
                                </div>
                                <p>Upgrading also renews the area.</p>
                                <div style={{ display: "flex", justifyContent: "right"}}>
                                    <Button type="hover-bottom-left" onClick={this.upgradeArea} disabled={this.state.selectedAreaSetting === null}>Upgrade</Button>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        );
    }
}

export default AreaInfo;